import { computed } from 'vue';

export function useBroadcastHelpers(props) {
  const {
    message,
    attachments,
    messageVariations,
    isUsingTemplate,
    selectedTemplate,
    recipients,
    minDelay,
    maxDelay,
  } = props;

  // Compute message type for display
  const messageTypeDisplay = computed(() => {
    if (isUsingTemplate.value && selectedTemplate.value) {
      return 'Template';
    }

    if (messageVariations.value.length > 0) {
      return `${messageVariations.value.length} Variações`;
    }

    const hasMessage = message.value.length > 0;
    const hasAttachments = attachments.value.length > 0;

    if (hasMessage && hasAttachments) {
      return 'Texto + Mídia';
    }
    if (hasMessage) {
      return 'Texto';
    }
    if (hasAttachments) {
      return 'Mídia';
    }

    return 'Texto';
  });

  // Calculate estimated broadcast time
  const estimatedBroadcastTime = computed(() => {
    if (recipients.value.length === 0) return null;

    const avgDelay = (minDelay.value + maxDelay.value) / 2;
    const totalSeconds = recipients.value.length * avgDelay;

    if (totalSeconds < 60) {
      return `${Math.round(totalSeconds)} segundos`;
    }

    if (totalSeconds < 3600) {
      const minutes = Math.round(totalSeconds / 60);
      return `${minutes} minuto${minutes > 1 ? 's' : ''}`;
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.round((totalSeconds % 3600) / 60);
    let timeStr = `${hours} hora${hours > 1 ? 's' : ''}`;

    if (minutes > 0) {
      timeStr += ` e ${minutes} minuto${minutes > 1 ? 's' : ''}`;
    }

    return timeStr;
  });

  return {
    messageTypeDisplay,
    estimatedBroadcastTime,
  };
}
